var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCompanyMicrosoft)?_c('VacationApplyInBatchDialogMs',{attrs:{"show":"","selectedUsers":[]}}):_c('VacationApplyInBatchDialog',{attrs:{"show":"","selectedUsers":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }